// web28_male_weight_gain_effects: a single multi-select screen shown only to
// men aged 30+ whose goal is losing weight/fat, and only to the experiment's
// variation arm. The `weightGainEffectsVisibleIf` expression below encodes the
// full trigger; the page in quiz.config.tsx just references it.

import { Age } from "./age";
import { Gender } from "./gender";
import { Goals } from "./goals";

// The arm-independent trigger: male, 30+, goal of losing weight/fat. Used both
// to gate the screen (combined with the arm) and to fire the experiment
// exposure event for BOTH arms once these conditions are known, so control and
// variation are comparable. getGender({gender},{physiology}) resolves
// non-binary users to the physiology they chose, matching the rest of the quiz.
const weightGainEffectsTrigger =
  `getGender({gender},{physiology}) = "${Gender.Male}"` +
  ` and ({age} = "${Age.Thirties}" or {age} = "${Age.Fourties}" or {age} = "${Age.OverFifty}")` +
  ` and ({goals} = "${Goals.LoseFat}" or {goals} = "${Goals.BuildMuscleAndLoseFat}")`;

// `web28Arm` is a survey variable set from the assigned Statsig arm in App.tsx.
const weightGainEffectsVisibleIf =
  `{web28Arm} = "variation" and (${weightGainEffectsTrigger})`;

enum WeightGainEffect {
  LowLibido = "Low Libido",
  HairLoss = "Hair Loss",
  SkinProblems = "Skin Problems",
  BrainFog = "Brain Fog / Trouble Focusing",
  LowEnergy = "Low Energy",
  NoneOfThese = "None of these",
}

const weightGainEffectsQuestion = {
  name: "weightGainEffects",
  title: "Men experience unique effects from weight gain",
  description: "Do you experience any of the following?",
  descriptionLocation: "underTitle",
  type: "checkbox",
  choices: [
    { value: WeightGainEffect.LowLibido, text: "Low Libido" },
    { value: WeightGainEffect.HairLoss, text: "Hair Loss" },
    { value: WeightGainEffect.SkinProblems, text: "Skin Problems" },
    { value: WeightGainEffect.BrainFog, text: "Brain Fog / Trouble Focusing" },
    { value: WeightGainEffect.LowEnergy, text: "Low Energy" },
    { value: WeightGainEffect.NoneOfThese, text: "None of these" },
  ],
  isRequired: true,
};

export {
  WeightGainEffect,
  weightGainEffectsQuestion,
  weightGainEffectsTrigger,
  weightGainEffectsVisibleIf,
};
